var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3.5,
    width: 8,
    height: 10,
    rx: 2,
    stroke: "#969696"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.5C10 14.6046 9.10457 15.5 8 15.5H4C2.89543 15.5 2 14.6046 2 13.5V7.5C2 6.39543 2.89543 5.5 4 5.5",
    stroke: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/Copy_icon.c7c31a55c55019d699648acc78db46d1.svg";
export { ForwardRef as ReactComponent };